<template>
  <div ref="terminalView" @touchmove.prevent @mousewheel.prevent style="display:flex;flex-direction:column;height: 100%;position:relative;width: 100%;" >
    <div style="flex: 0 0 auto;background-color: white;width: 99%;z-index: 10;">
      <a-button
          v-if="term"
          style="margin-right:10px"
          @click="reConnect"
      >{{$t("page_terminal_rechoose")}}</a-button>
      <a-button
          @click="showDrawer = true;reset();"
          :disabled="!this.term"
      >{{$t('文件')}}{{$t("page_terminal_download_and_upload")}}</a-button>

      <a-input-search
          v-if="term"
          style="width:240px"
          v-model="searchKey"
          placeholder="输入文本关键字"
          enter-button="查找文本"
          @search="onSearch"
      />

      <div style="float: right;margin-bottom: 3px;">
        <a-checkbox-group v-model="keyType"  >
          <a-checkbox value="ctrl">
            Ctrl
          </a-checkbox>
          <a-checkbox value="alt">
            Alt
          </a-checkbox>
          <a-checkbox value="Shift">
            Shift
          </a-checkbox>
          <a-checkbox value="sys">
            Sys
          </a-checkbox>
        </a-checkbox-group>
        <a-select v-model="keyCode">
          <a-select-option value="Digit0">
            0
          </a-select-option>
          <a-select-option value="Digit1">
            1
          </a-select-option>
          <a-select-option value="KeyC">
            C
          </a-select-option>
          <a-select-option value="KeyV">
            V
          </a-select-option>
          <a-select-option value="KeyT">
            T
          </a-select-option>
        </a-select>
        <a-button @click="sendKey()">发送快捷键</a-button>
      </div>
    </div>

    <div style="flex: 1 ; width:100%;height:100%;overflow-x: scroll;margin-bottom:-8px;">
      <div ref="container" style="overflow: hidden;z-index: 1;width:2000px;height:100%;background:#000;position: static">

      </div>
    </div>
    

    <wm-drawer
        ref="drawer"
        class="terminal-drawer"
        :extraStyle="{padding:0}"
        :width="600"
        :visible="showDrawer"
        @close="showDrawer = false"
        :container="container"
    >
      <a-tabs
          type="card"
          v-model="activeTab"
          style="height: 100%;background: #fff;"
          :tabBarStyle="barStyle"
      >
        <a-tab-pane :tab="$t('page_terminal_upload')" key="1">
          <div
              style="align-items: center; display: flex;padding:0 30px 50px"
          >
            <span>{{this.$t("page_terminal_upload_dir")}}:</span>
<!--            <a-input v-model="dirname" style="width:300px;margin-left:10px;margin-right:10px"></a-input>-->
<!--            <app-select-->
<!--                :placeholder="'目标路径'"-->
<!--                :list="paths"-->
<!--                v-model="dirname"-->
<!--                :show-search="true"-->
<!--                style="width:300px;margin-left:10px;margin-right:10px"-->
<!--            />-->
              <a-dropdown
                  :trigger="['click']"
              >
                <a-input-search
                    v-model="dirname"
                    style="width:400px;margin-left: 10px;"
                    allowClear
                    :placeholder="$t('请输入目标路径')"
                    :enterButton="$t('选择目标路径')"
                    @search="() => search()"
                    @click.prevent
                />
                <template #overlay>
                  <a-menu :v-model="dropModel" @click="onClickUpload" style="height: 350px;overflow-y: scroll">
                    <a-menu-item v-for="item in paths" :key="item.label" :label="item.label" :value="item.value">{{item.value}}</a-menu-item>
                  </a-menu>
                </template>
            </a-dropdown>
          </div>
          <div class="current-panel" style="padding-left:100px;padding-right:100px;">
            <a-upload-dragger
                class="terminal-upload"
                :file-list="[]"
                :before-upload="beforeUpload"
                name="file"
                :multiple="false"
                :disabled="disable"
            >
              <p class="ant-upload-drag-icon">
                <a-icon type="inbox" />
              </p>
              <p class="ant-upload-text">{{$t("page_terminal_upload_tips")}}</p>
              <p class="ant-upload-hint">{{$t("page_terminal_upload_supports")}}</p>
            </a-upload-dragger>
            <div
                style="color:rgba(0,0,0,.65);padding: 10px 8px;display:flex;align-items:center;justify-content:space-between"
            >
              <span>{{file_name}}</span>
              <a-button v-if="disable" type="link" @click="handleCancel">{{this.$t("cancel")}}</a-button>
            </div>
            <a-progress v-if="disable" :percent="file_process" />
          </div>
        </a-tab-pane>
        <a-tab-pane :tab="$t('page_terminal_download')" key="2">
          <div class="current-panel" style="padding-left:30px;">
            <div style="align-items:center;display: flex">
              <span>{{$t("page_terminal_filename")}}:</span>
<!--              <a-input v-model="filename" style="width:350px;margin-left:20px"></a-input>-->
              <a-dropdown
                  :trigger="['click']"
              >
                <a-input-search
                    v-model="filename"
                    style="width:400px;margin-left: 10px;"
                    allowClear
                    :placeholder="$t('请输入目标路径')"
                    :enterButton="$t('选择目标路径')"
                    @search="() => search()"
                    @click.prevent
                />
                <template #overlay >
                  <a-menu :v-model="dropModel" @click="onClick" style="height: 350px;overflow-y: scroll">
                    <a-menu-item v-for="item in paths" :key="item.label" :label="item.label" :value="item.value">{{item.value}}</a-menu-item>
                  </a-menu>
                </template>
              </a-dropdown>
            </div>

            <a-button
                style="margin-top:16px;margin-left:80px;"
                type="primary"
                @click="handleDownload"
                :disabled="disable"
            >{{$t("page_terminal_download")}}</a-button>
            <a-button
                v-if="disable"
                style="margin-left:8px"
                type="link"
                @click="handleCancel"
            >{{this.$t("cancel")}}</a-button>
            <a-progress v-if="disable" :percent="file_process" />
          </div>
        </a-tab-pane>
      </a-tabs>
    </wm-drawer>

  </div>
</template>

<script>
import _ from "lodash";
import Terminal from "@/views/iot-console/gateway-admin/components/Terminal";
import {pathList} from './data'

export default {
  name: "TerminalView",
  components: {Terminal},
  data (){
    return {
      term: null,
      showDrawer: false,
      searchKey:'',
      keyType: [],
      keyCode: '',
      activeTab: "1",
      barStyle: {
        background: "#f8f8f8",
        // width: "120px",
      },
      dirname:'',
      disable: false,
      file_name: "",
      file_process: 0,
      filename: "",
      fileList: [],
      path: '',
      dropModel:false
    }
  },
  props : {
    selectGateway : {},
    getToken:{},
    userName:{},
    baseUrl:{},
    container:{
      type:String,
      default:'black-main'
    },
    hardwareType:{
      type: String,
      default: 's1'
    }
  },
  computed : {
    paths(){
      return pathList[this.hardwareType]
    }
  },
  methods: {
    init(){
      this.$nextTick(()=>{
        this.reset()
        this.initTerminal()
      })

    },
    reset() {
      this.file_process = 0;
      this.file_name = "";
    },
    reConnect() {
      this.reset();
      this.$nextTick(() => {
        this.initTerminal();
      });
    },
    onSearch(){
      if(!this.term){
        return;
      }
      if(!this.searchKey || this.searchKey.length ===0){
        return;
      }
      this.term.findText(this.searchKey,
          {
            regex: false,
            wholeWord: false,
            caseSensitive: false,
            incremental: false,
            previous: false
          }
      );
    },
    remove(file) {
      const index = this.fileList.findIndex((item) => item === file);
      this.fileList.splice(index, 1);
      return true;
    },
    uploadOnProgress(error, filename, progress){
      if (error){
        console.error("传输文件出错:fileName:", filename,"error:", error);
            // this.$message.success(this.$t("page_terminal_upload_success"));
        this.$message.error(this.$t("page_terminal_upload_fail"));
      }
      else{
        this.file_process = Number(progress.toFixed(2));
      }
      if(progress===100){
        this.$message.success(this.$t("page_terminal_upload_success"));
      }
    },
    sendKey(){
      if(!this.term){
        return;
      }
      if(!this.keyCode || this.keyCode.length===0){
        return;
      }

      const isCtrl = this.keyType.find(c=>c==='ctrl')!==undefined;
      const isShift = this.keyType.find(c=>c==='shift')!==undefined;
      const isAlt = this.keyType.find(c=>c==='alt')!==undefined;
      const isSys = this.keyType.find(c=>c==='sys')!==undefined;
      this.term.sendKeyEvent(this.keyCode, isCtrl, isAlt, isShift, isSys);
    },
    beforeUpload(file) {
      if(!this.dirname || this.dirname.length===0){
        this.$message.error('必须填写路径才能上传');
        return false;
      }
      this.file_name = file.name;
      this.disable = true;
      // dirname 需要以 / 结尾
      const path = this.guardEndWith(this.dirname);
      this.term.uploadFile({files: [file]}, path ,this.uploadOnProgress)
          .then(() => {
            // this.$message.success(this.$t("page_terminal_upload_success"));
          })
          .catch(err=>{
            console.error('上传文件失败:err',err);
            this.file_process = 0;
            this.file_name = "";
            this.$message.error(this.$t("page_terminal_upload_fail"));
          })
          .finally(()=>{
            this.disable = false;
          });
      return false;
    },

    guardEndWith(value){
      const v=_.trim(value);
      if(_.endsWith(v,'/')){
        return v;
      }
      return `${v}/`;
    },

    handleCancel() {
      this.term
          .abortFileTransmission()
          .then((err) => {
            this.disable = false;
            this.file_process = 0;
            this.file_name = "";
          })
          .catch((err) => {
            this.$message.error(this.$t("cancel_fail"));
          });
    },
    handleDownload() {
      this.disable = true;
      this.file_process = 0;

      const filepath = this.term.downloadFile(
          this.filename,
          (error, filename, progress) => {
            // debugger
            console.log(error, filename, progress);
            if (error) {
              this.disable = false;
              this.file_process = 0;
              this.$message.error(this.$t("page_terminal_download_fail"));
            }
            if (!error) {
              this.file_process = Number(progress.toFixed(2));
              if (progress == 100) {
                this.disable = false;
                this.$message.success(this.$t("page_terminal_download_success"));
              }
            }
          }
      );
    },
    async initTerminal() {
      if (this.term) {
        // this.$refs.terminal.removeChild(this.$refs.terminal.firstChild);
        // const ele = document.createElement("div");
        // ele.style = "width:100%;height:100%";
        // this.$refs.terminal.appendChild(ele);
        // this.term.disconnect();
        // this.term = null;
        this.term.uninitialize();
        this.term = null;
      }
      await this.$nextTick();

      const terminalView = this.$refs.terminalView;
      const width = terminalView.clientWidth - 18;
      const height = terminalView.clientHeight ;
      var term = new RemoteTerminal({
        cols: parseInt(width / 9),
        rows: parseInt(height / 20),
        bell: true,
        fileTransferBlockSize: 1024 * 128,
        webLink: true,
        windowsMode: true,
        connectingString: "[终端客户端消息] 正在连接到目标服务器 ...",
        connectedString: "[终端客户端消息] 目标服务器已连接.",
        disconnectedString: "与目标服务器的连接已断开"
      });


      term.initialize(this.$refs.container);

      let options = {
        TerminalNodeId: this.selectGateway,
        ClientNodeId: this.userName,
        TerminalSessionToken: this.getToken,
      };

      term.connect(`${this.baseUrl}`, options).then();

      this.term = term;
    },
    search(){
      this.dropModel = true
    },
    onClick(e){
      this.filename = e.key
    },
    onClickUpload(e){
      this.dirname = e.key
    }
  },
  watch:{
    // selectGateway(){
    //   this.initTerminal();
    // }
  }
}
</script>

<style lang="less">

.terminal-upload .ant-upload-list-item-card-actions {
  display: none !important;
}
.terminal-drawer .ant-drawer-close {
  width: 40px;
  height: 40px;
  line-height: 40px;
}

.terminal-drawer {
  .ant-tabs-nav > div {
    // display: flex;

    .ant-tabs-tab.ant-tabs-tab-active::before {
      border-top: 3px solid #4a90e2 !important;
    }
  }

  .ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab {
    margin-right: 0px;
    box-sizing: border-box;
    border-left: none;
  }

  .ant-tabs-tab {
    padding-left: 40px !important;
    padding-right: 40px !important;
  }
}

.xterm {
  font-feature-settings: "liga" 0;
  position: relative;
  user-select: none;
  -ms-user-select: none;
  -webkit-user-select: none;
}

.xterm.focus,
.xterm:focus {
  outline: none;
}

.xterm .xterm-helpers {
  position: absolute;
  top: 0;
  /**
     * The z-index of the helpers must be higher than the canvases in order for
     * IMEs to appear on top.
     */
  z-index: 5;
}

.xterm .xterm-helper-textarea {
  padding: 0;
  border: 0;
  margin: 0;
  /* Move textarea out of the screen to the far left, so that the cursor is not visible */
  position: absolute;
  opacity: 0;
  left: -9999em;
  top: 0;
  width: 0;
  height: 0;
  z-index: -5;
  /** Prevent wrapping so the IME appears against the textarea at the correct position */
  white-space: nowrap;
  overflow: hidden;
  resize: none;
}

.xterm .composition-view {
  /* TODO: Composition position got messed up somewhere */
  background: #000;
  color: #fff;
  display: none;
  position: absolute;
  white-space: nowrap;
  z-index: 1;
}

.xterm .composition-view.active {
  display: block;
}

.xterm .xterm-viewport {
  /* On OS X this is required in order for the scroll bar to appear fully opaque */
  background-color: #000;
  overflow-y: scroll;
  cursor: default;
  position: absolute;
  right: 0;
  left: 0;
  top: 0;
  bottom: 0;
}
.xterm-screen {
  height: 90%
}
.xterm .xterm-screen {
  position: relative;
  background: #000;
  width: 100% !important;
  height: 100%;
}

.xterm .xterm-screen canvas {
  position: absolute;
  left: 0;
  top: 0;
}

.xterm .xterm-scroll-area {
  visibility: hidden;
}

.xterm-char-measure-element {
  display: inline-block;
  visibility: hidden;
  position: absolute;
  top: 0;
  left: -9999em;
  line-height: normal;
}

.xterm {
  cursor: text;
}

.xterm.enable-mouse-events {
  /* When mouse events are enabled (eg. tmux), revert to the standard pointer cursor */
  cursor: default;
}

.xterm.xterm-cursor-pointer {
  cursor: pointer;
}

.xterm.column-select.focus {
  /* Column selection mode */
  cursor: crosshair;
}

.xterm .xterm-accessibility,
.xterm .xterm-message {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  z-index: 10;
  color: transparent;
}

.xterm .live-region {
  position: absolute;
  left: -9999px;
  width: 1px;
  height: 1px;
  overflow: hidden;
}

.xterm-dim {
  opacity: 0.5;
}

.xterm-underline {
  text-decoration: underline;
}

//::-webkit-scrollbar {
//  width: 0 !important;
//}
//::-webkit-scrollbar {
//  width: 0 !important;height: 0;
//}
</style>